/**
 * 数据字典
 *
 * 配置方式：
 * 1. 键值对，用于只匹配文本
 * 2. 数组，用于需要页面列表展示，统一使用 [{ value, text }] 格式方便过滤器调用
 *
 * 获取方式：
 * 1. 组件内部直接通过 this.$option.contractStatus 获取选项数据
 * 2. 通过模板过滤器 {{statusCode | option('contractStatus')}} 获取选项文本
 * 3. 组件内部通过方法 this.$option.get('contractStatus', statusCode) 获取选项文本
 */
import Vue from 'vue'

const options = {
  // 合同状态
  contractStatus: {
    0: '待填写',
    1: '待签署',
    2: '已完成',
    3: '已逾期',
    4: '已撤销',
    5: '已拒签',
    6: '待审批',
    7: '审批不通过',
    8: '审批撤销',
    10: '已拒填'
  },

  // 合同审批状态
  contractApproveStatus: {
    0: '审批中',
    1: '审批通过',
    2: '审批不通过',
    3: '无需审批'
  },

  // 填写状态
  fillStatus: {
    0: '待他人填写',
    1: '待我填写',
    2: '已填写',
    3: '已拒填',
    4: '已撤销',
    5: '已转发',
    6: '无需填'
  },

  // 签署状态
  signStatus: {
    0: '待他人签署',
    1: '待我签署',
    2: '已签署',
    3: '已拒签',
    4: '已撤销',
    5: '已转签',
    6: '无需签署'
  },

  // 签署控件
  signWidget: {
    0: '签名',
    1: '印章',
    2: '日期',
    3: '单行文本',
    4: '多行文本',
    5: '复选框'
  },

  // 个人认证状态
  userAuthStatus: {
    0: '未认证',
    1: '审核中',
    2: '已认证',
    3: '审核不通过'
  }
}

// 获取字典选项值
options.get = (optionKey, value) => {
  const option = options[optionKey]

  if (Array.isArray(option)) {
    const item = option.find(i => i.value === value)
    return item ? item.text : null
  }

  if (typeof option === 'object') {
    return option[value]
  }

  return null
}

// 继承原型
Vue.prototype.$option = options

// 过滤器获取选项值
Vue.filter('option', (value, optionKey) => options.get(optionKey, value))

export default options
